import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { AiRovoCurrentRouteConfigurationProvider } from './AiRovoCurrentRouteConfigurationProvider.tsx';

export const AiRovoCurrentRouteConfigurationProviderWithBoundary = (): React.JSX.Element | null => {
	return (
		<JSErrorBoundary
			fallback="unmount"
			id="rovo-current-route-configuration-provider"
			packageName="ai-rovo-actions-route-provider"
			teamName="reverie"
		>
			<UFOSegment name="rovo-current-route-configuration-provider">
				<AiRovoCurrentRouteConfigurationProvider />
			</UFOSegment>
		</JSErrorBoundary>
	);
};
